import { createQuery } from "@tanstack/solid-query";
import { useToolClient } from "./tool-client";

export function createToolQuery<R = unknown, P extends Record<string, unknown> = Record<string, unknown>>(
  options: () => {
    tool: string;
    params?: P;
    enabled?: boolean;
    refetchInterval?: number;
    staleTime?: number;
  },
) {
  const client = useToolClient();
  return createQuery(() => {
    const o = options();
    return {
      queryKey: [o.tool, o.params] as const,
      queryFn: () => client.call<R, P>(o.tool, o.params || ({} as P)),
      enabled: o.enabled ?? true,
      refetchInterval: o.refetchInterval,
      staleTime: o.staleTime ?? 10_000,
    };
  });
}
